import React from "react";
import { IoInformation } from "react-icons/io5";
interface Props {
	label: string;
	value: number;
	info?: string; // Optional info text to show in tooltip
}

const LinearProgressWithLabel: React.FC<Props> = ({ label, value, info }) => {
	const getColor = (value: number) => {
		if (value < 60) return "bg-red-500"; // danger
		if (value < 80) return "bg-yellow-500"; // warning
		return "bg-green-500"; // success
	};

	return (
		<div className="py-0">
			<div className="w-full">
				<div className="flex justify-between mb-1.5">
					<div className="flex items-center gap-1">
						<span className="text-gray-500 text-sm mr-1">{label}</span>
						{info && (
							<div className="relative group">
								<div className="flex items-center justify-center w-3.5 h-3.5 rounded-full bg-gray-200 cursor-help">
									<IoInformation className="h-3 w-3 text-gray-600" />
								</div>
								<div className="absolute bottom-full left-1/2 -translate-x-1/3 mb-2 hidden group-hover:block">
									<div className="bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
										{info}
									</div>
								</div>
							</div>
						)}
					</div>
					<span className="text-gray-500 text-sm">{`${Math.round(
						value
					)}%`}</span>
				</div>
				<div className="w-full bg-gray-200 rounded-md h-4">
					<div
						className={`h-full rounded-md transition-all duration-300 ${getColor(
							value
						)}`}
						style={{ width: `${value}%` }}
					/>
				</div>
			</div>
		</div>
	);
};

export default LinearProgressWithLabel;
